var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagDominica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.13 31.6931C25.4552 30.4384 30.4378 25.4557 31.6925 19.1306H19.13V31.6931Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.306641 19.1306C1.56133 25.4557 6.54395 30.4384 12.8691 31.6931V19.1306H0.306641Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6925 12.8696C30.4378 6.5445 25.4552 1.56188 19.13 0.307129V12.8696H31.6925Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8691 0.307129C6.54395 1.56188 1.56133 6.5445 0.306641 12.8696H12.8691V0.307129Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9561 19.1306H12.8691V31.6931C13.5502 31.8282 14.2469 31.9197 14.9561 31.9654V19.1306Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9561 12.8697V0.0349121C14.2469 0.0805371 13.5501 0.1721 12.8691 0.307162V12.8697H14.9561Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0431 0.0348125C16.6979 0.0125 16.3502 0 15.9996 0C15.6489 0 15.3012 0.0125 14.9561 0.0348125V12.8696H17.043V0.0348125H17.0431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9561 31.9651C15.3012 31.9874 15.6489 31.9999 15.9996 31.9999C16.3502 31.9999 16.6979 31.9874 17.0431 31.9651V19.1304H14.9561V31.9651H14.9561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8699 14.9566V12.8696H0.307406C0.172281 13.5508 0.0807813 14.2474 0.0351562 14.9566H12.8699Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1308 14.9566H31.9656C31.92 14.2474 31.8284 13.5508 31.6933 12.8696H19.1308V14.9566H19.1308Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1309 17.0435H31.9657C31.9879 16.6985 32.0004 16.3507 32.0004 16C32.0004 15.6494 31.9879 15.3016 31.9656 14.9565H19.1309V17.0435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0348125 14.9565C0.0125625 15.3016 0 15.6494 0 16C0 16.3507 0.0125625 16.6985 0.0348125 17.0435H12.8696V14.9566H0.0348125V14.9565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.6523C20.2262 23.6523 23.6522 20.2263 23.6522 16.0001C23.6522 11.7739 20.2262 8.3479 16 8.3479C11.7738 8.3479 8.34781 11.7739 8.34781 16.0001C8.34781 20.2263 11.7738 23.6523 16 23.6523Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7437 16.854C17.1745 15.7157 16.4347 14.5619 16.4347 14.5619C16.4347 14.5619 16.4531 14.0366 16.4531 13.7236C16.4531 13.2521 16.0708 12.8699 15.5993 12.8699C15.1526 12.8699 14.7866 13.2131 14.7493 13.65C14.3981 13.6729 14.1201 13.9643 14.1201 14.3213C14.1201 14.5809 14.2672 14.8058 14.4825 14.9182C14.5895 14.668 14.799 14.4726 15.0581 14.3836C15.1003 14.4181 15.1457 14.449 15.1941 14.4752L15.3035 14.5276C15.3035 14.5276 14.898 15.6707 14.898 16.2849C14.898 18.0114 16.0363 18.5438 16.0363 18.5438V18.5616L15.4671 19.1307H16.6055V17.9924L17.1746 18.5616C17.1796 18.5509 18.2528 17.8722 17.7437 16.854Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 9.73926L16.2593 10.5364H17.0975L16.4194 11.0291L16.6785 11.8262L16.0003 11.3336L15.3222 11.8262L15.5813 11.0291L14.9032 10.5364H15.7413L16.0003 9.73926Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3203 10.9351L12.9983 11.4278L13.6765 10.9351L13.4175 11.7323L14.0956 12.2249L13.2574 12.2249L12.9984 13.0221L12.7393 12.2249L11.9012 12.2249L12.5793 11.7322L12.3203 10.9351Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0459 14.0654H10.884L11.143 13.2683L11.402 14.0654L12.2402 14.0654L11.5621 14.5581L11.8212 15.3552L11.143 14.8626L10.465 15.3552L10.7239 14.5581L10.0459 14.0654Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0459 17.9348L10.7239 17.4422L10.4649 16.645L11.143 17.1377L11.8211 16.645L11.5621 17.4421L12.2403 17.9348L11.402 17.9349L11.143 18.732L10.884 17.9348H10.0459Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3203 21.0651L12.5793 20.2681L11.9011 19.7755H12.7393L12.9984 18.9783L13.2574 19.7754H14.0956L13.4175 20.2681L13.6765 21.0652L12.9983 20.5725L12.3203 21.0651Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 22.261L15.7413 21.464H14.9032L15.5813 20.9713L15.3222 20.1741L16.0003 20.6667L16.6784 20.1741L16.4194 20.9713L17.0975 21.4639L16.2593 21.464L16.0003 22.261Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6803 21.0651L19.0023 20.5725L18.3243 21.0653L18.5832 20.2681L17.9051 19.7755L18.7433 19.7754L19.0022 18.9783L19.2613 19.7755H20.0995L19.4214 20.2681L19.6803 21.0651Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9551 17.9347H21.1171L20.858 18.7319L20.599 17.9348H19.7607L20.4389 17.4421L20.1798 16.645L20.858 17.1376L21.536 16.645L21.2771 17.4421L21.9551 17.9347Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9551 14.0654L21.2771 14.558L21.5361 15.3551L20.858 14.8625L20.1799 15.3552L20.4389 14.5581L19.7607 14.0654L20.599 14.0653L20.8579 13.2683L21.1171 14.0654H21.9551Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6803 10.9351L19.4214 11.7321L20.0995 12.2248H19.2613L19.0023 13.022L18.7433 12.2249L17.9051 12.2249L18.5832 11.7321L18.3242 10.9351L19.0023 11.4277L19.6803 10.9351Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDominica);
export default __webpack_public_path__ + "static/media/flag_dominica.197cbd4096f5dbf4147dccd7f417e7ba.svg";
export { ForwardRef as ReactComponent };